import React, { useEffect, useRef, useState } from 'react';
import DotsMenu from './DotsMenu';
import { useIntl } from 'react-intl';
import styles from './MLClassContainer.mod.scss';
import clsx from 'clsx';
import { Button } from '@mui/material';
import CamaraSample from '../../../../assets/icons/camara.jsx';
import DotsVerticalIcon from '@assets/icons/dotsVertical';

import WifiOffIcon from '@assets/icons/wifiOff';
import TrashWhite from '@assets/icons/trashWhite';





const MLClassContainer = ({
  sample,
  keyIndex,
  onEditClassName,
  existingNames = [],
  loading,
  onDeleteClass,
  index,
  openSamplesDialog,
  onHideClass,
  onShowClass,
  isCreabots,
  darktheme,
}) => {
  const intl = useIntl();

  const updateClassName = (index, newName) => {
    if (onEditClassName) {
      onEditClassName(index, newName);
    }
  }

  const handleNameClick = () => {
    if (sample.name && sample.name.trim() !== '' && sample.image?.length > 0 && !sample.nonEditable) {
      setIsEditing(true);
      setTempName(sample.name);
    }
  }

  const isDuplicateName = (name) => {
    return existingNames.includes(name.trim().toLowerCase());
  };

  const handleSaveName = () => {
    if (tempName.trim() !== '' && !isDuplicateName(tempName)) {
      updateClassName(index, tempName.trim());
      setDuplicateError(false);
    } else if (isDuplicateName(tempName)) {
      setDuplicateError(true);
      return;
    }
    setIsEditing(false);
  }

  const handleCancelEdit = () => {
    setTempName(sample.name || '');
    setDuplicateError(false);
    setIsEditing(false);
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSaveName();
    } else if (e.key === 'Escape') {
      handleCancelEdit();
    }
  }

  const removeClass = (id) => {
    if (onDeleteClass) {
      onDeleteClass(id);
    }
  }
  const dotsIconRef = useRef(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [tempName, setTempName] = useState(sample.name || '');
  const [duplicateError, setDuplicateError] = useState(false);
  const inputRef = useRef(null);
  // El estado de oculto ahora viene siempre de sample.active
  const hidden = !sample.active;

  // Enfocar el input cuando se activa el modo de edición
  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [isEditing]);

  // Actualizar tempName cuando cambie sample.name
  useEffect(() => {
    setTempName(sample.name || '');
  }, [sample.name]);

  return (
    <div key={`class-${index}`} >
      <div
        className={clsx(
          styles.classContainer,
          sample.name && sample.name.trim() !== '' && sample.image?.length > 0 && styles.completedClassContainer,
          hidden && styles.classContainerHidden,
        )}
        style={sample.name && sample.name.trim() !== '' && sample.image?.length > 0 ? { cursor: 'pointer' } : {}}
      >
        <div className={styles.label}>
          <div className={styles.labelWithIcon}>
            {isEditing ? (
              <>
                <input
                  ref={inputRef}
                  className={clsx(styles.input, duplicateError && styles.inputError)}
                  type="text"
                  value={tempName}
                  onChange={(e) => {
                    setTempName(e.target.value);
                    setDuplicateError(isDuplicateName(e.target.value));
                  }}
                  onBlur={handleSaveName}
                  onKeyDown={handleKeyDown}
                  placeholder={intl.formatMessage({ id: 'machineLearning.classContainer.defaultName' })}
                  style={{ marginTop: 0, height: 'auto', minHeight: 'auto', fontSize: '16px', fontWeight: '500' }}
                />
                {duplicateError && (
                  <span className={styles.errorText}>
                    {intl.formatMessage({ id: 'machineLearning.classContainer.duplicateName' })}
                  </span>
                )}
              </>
            ) : (
              <label
                className={clsx(
                  styles.className,
                  sample.name && sample.name.trim() !== '' && sample.image?.length > 0 && !sample.nonEditable && styles.editableClassName
                )}
                onClick={handleNameClick}
              >
                {(sample.nonEditable) ? intl.formatMessage({ id: sample.name }) : (sample.name || intl.formatMessage({ id: 'machineLearning.classContainer.defaultName' }))}
              </label>
            )}
            {sample.image?.length > 0 && !sample.nonEditable && (
              <>
                <Button
                  ref={dotsIconRef}
                  className={styles.dotsButton}
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    setMenuOpen(true);
                  }}


                >
                  <DotsVerticalIcon className={styles.dotsIcon} />
                </Button>
                <DotsMenu
                  open={menuOpen}
                  anchorRef={dotsIconRef}
                  onDelete={() => removeClass(index)}
                  onHide={() => { if (onHideClass) onHideClass(index); }}
                  onShow={() => { if (onShowClass) onShowClass(index); }}
                  isHidden={hidden}
                  onClose={() => setMenuOpen(false)}
                  className={sample.name}
                  sampleCount={sample.image?.length || 0}
                  imageUrl={sample.image?.[0]}
                  isCreabots={isCreabots}
                  darktheme={darktheme}
                />
              </>
            )}
            {sample.image?.length === 0 && !sample.nonEditable && (
              <>
                <Button className={styles.deleteButton} onClick={() => removeClass(index)}>
                  <TrashWhite className={styles.trash} />
                </Button>
              </>
            )}
          </div>
          {hidden && (
            <div className={styles.classHiddenWrapper}>
              <div className={styles.classHiddenContent}>
                <WifiOffIcon className={styles.eyeOffIcon} />
                <div className={styles.classHiddenText}>
                  {intl.formatMessage({ id: 'machineLearning.classContainer.classHiddenText' })}
                </div>
              </div>
              <div className={styles.classHiddenSubText}>
                {intl.formatMessage({ id: 'machineLearning.classContainer.classHiddenSubText' })}
              </div>
            </div>
          )}

          {!(sample.name && sample.name.trim() !== '' && sample.image?.length > 0) && !hidden ? (
            <>
              {!sample.nonEditable ? (
                <>
                  <input
                    className={clsx(styles.input, duplicateError && styles.inputError)}
                    id={`mlClass-${keyIndex}`}
                    type='text'
                    value={sample.name}
                    onChange={(e) => {
                      const newName = e.target.value;
                      const isDup = isDuplicateName(newName);
                      setDuplicateError(isDup);
                      if (!isDup) {
                        updateClassName(index, newName);
                      }
                    }}
                    placeholder={intl.formatMessage({ id: 'machineLearning.classContainer.defaultName' })}
                  />
                  {duplicateError && (
                    <span className={styles.errorText}>
                      {intl.formatMessage({ id: 'machineLearning.classContainer.duplicateName' })}
                    </span>
                  )}
                </>
              ) : null}
              <Button
                className={styles.takeSamples}
                id={`ml-takeSample-${keyIndex}`}
                onClick={() => openSamplesDialog(index)}
                disabled={
                  loading ||
                  !sample.name ||
                  sample.name.trim() === '' ||
                  sample.name === intl.formatMessage({ id: 'machineLearning.classContainer.defaultName' })
                }
                style={{ justifyContent: 'flex-start', alignItems: 'center' }}
              >
                <CamaraSample />
                {intl.formatMessage({ id: 'machineLearning.classContainer.takeSamples' })}
              </Button>
            </>
          ) : null}
          {sample.image?.length > 0 && !hidden && (
            <div className={styles.samplesInfoRow} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span className={styles.samplesCount}>
                {sample.image?.length} {intl.formatMessage({ id: 'machineLearning.samples' })}
              </span>
              <button
                className={styles.editSamplesButton}
                onClick={(e) => {
                  e.stopPropagation();
                  openSamplesDialog(index);
                }}
              >
                {intl.formatMessage({ id: 'machineLearning.classContainer.editSamples' })}
              </button>
            </div>
          )}
        </div>
        {/* <div className={styles.actionButtons}>
          {keyIndex > 0 ? (
            <button onClick={() => removeClass(index)} disabled={(loading)}>{intl.formatMessage({ id: 'machineLearning.classContainer.deleteClass' })}</button>
          ) : (null)}
        </div> */}
      </div>
    </div>
  );
};


export default MLClassContainer;